import {
  TELEGRAM_LINK,
  WHATSAPP_LINK,
} from '@/components/general/Footer/helpers';

const TelegramLogo = '/networks/telegramLogo.svg';
const WhatsAppLogo = '/networks/whatsAppLogo.svg';
export interface Network {
  textKey: string;
  icon: string;
  link: string;
  id: string;
}

export const networkItems: Network[] = [
  {
    textKey: 'networksModal.followOn',
    icon: TelegramLogo,
    link: TELEGRAM_LINK,
    id: 'telegram',
  },
  {
    textKey: 'networksModal.followOn',
    icon: WhatsAppLogo,
    link: WHATSAPP_LINK,
    id: 'whatsapp',
  },
];
